import React, { Suspense, useEffect, useState } from 'react';
import {
  Box,
  Button,
  Heading,
  Text,
  VStack,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Divider,
  useToast,
  HStack,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  Tooltip,
  Flex,
  useDisclosure,
  Spinner,
  MenuItem,
  MenuList,
  Menu,
  MenuButton,
} from '@chakra-ui/react';
import { FiCreditCard, FiDollarSign, FiEdit } from 'react-icons/fi';
import axios from 'axios';
import { FaCreditCard, FaPrint } from 'react-icons/fa';
import FacturacionComponent from 'views/Facturacion/PagoAPManual';
import CrearActualizarToma from 'views/AguaPotable/AltaToma';
import TransaccionDetails from './DetallePagos';
import { ChevronDownIcon } from '@chakra-ui/icons';
interface Toma {
  id: string;
  idPropietario: string;
  idTomasx: string;
  fechaVinculacion: string;
  usuarioVinculacion: string | null;
  Tomasx: {
    Cuenta: number;
    domicilio: string;
    fechaAlta: string;
    municipio: string;
  };
  Propietario: {
    nombre: string;
    primerApellido: string;
    segundoApellido: string;
    rfc: string;
  };
}
interface Pago {
  estatus_de_cancelacion: string;
  RFCReceptor: string;
  ID: string;
  Fecha: string;
  Monto: number;
  MetodoPago: string;
  UUID: string;
}

interface HistorialPagosProps {
  idClaveCatastral: string;
}

const HistorialPagosAP: React.FC<HistorialPagosProps> = ({
  idClaveCatastral,
}) => {
  const [tomas, setTomas] = useState<Toma[]>([]);
  const [pagos, setPagos] = useState<Record<string, Pago[]>>({});
  const [selectedToma, setSelectedToma] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const {
    isOpen: isBajaOpen,
    onOpen: onBajaOpen,
    onClose: onBajaClose,
  } = useDisclosure();

  useEffect(() => {
    const fetchTomas = async () => {
      try {
        const response = await axios.get(
          `http://52.91.130.91:5000/api/tomasx/propietario_tomas?propietarioId=${idClaveCatastral}`,
        );

        setTomas(response.data);

        if (response.data.length > 0) {
          setSelectedToma(response.data[0].idTomasx);
          await fetchPagos(
            'AP-' + response.data[0].Tomasx.Cuenta,
            response.data[0].idTomasx,
          );
        }
      } catch (error) {
        console.error('Error al obtener tomas:', error);
        toast({
          title: 'Error al cargar datos',
          description: 'No se pudieron cargar las tomas del propietario.',
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchTomas();
  }, [idClaveCatastral]);
  const [selectedPagoId, setSelectedPagoId] = useState<string | null>(null);
  const {
    isOpen: isDetailOpen,
    onOpen: onDetailOpen,
    onClose: onDetailClose,
  } = useDisclosure();

  const handleVerDetalle = (pagoId: string) => {
    setSelectedPagoId(pagoId);
    onDetailOpen();
  };

  const fetchPagos = async (idToma: string, id: string) => {
    try {
      const response = await axios.get(
        `http://52.91.130.91:5000/api/Transacciones/agua_prop/${idToma}`,
      );
      console.log('Pagos recibidos:', response.data); // Agregar log para verificar datos

      setPagos((prev) => ({
        ...prev,
        [id]: response.data,
      }));
    } catch (error) {
      console.error(`Error al obtener pagos para la toma ${idToma}:`, error);
    }
  };

  const {
    // isOpen: isHistorialPagosAPOpenX,
    onOpen: onHistorialPagosAPOpenX,
    onClose: onHistorialPagosAPCloseX,
  } = useDisclosure();
  const [selectedPropietario, setSelectedPropietario] = useState<string | null>(
    null,
  );
  const [fechaDesde, setFechaDesde] = useState<string | null>(null);
  const [fechaHasta, setFechaHasta] = useState<string | null>(null);
  const [tabSeleccionada, setTabSeleccionada] = useState<string>('T-5690');
  const [isHistorialPagosAPOpenX, setHistorialPagosAPOpenX] = useState(false);
  const [selectedTomax, setSelectedTomax] = useState<Toma | null>(null); // Guarda la toma completa

  const openPagoModal = (toma: Toma) => {
    setSelectedTomax(toma);
    setHistorialPagosAPOpenX(true);
  };

  const closePagoModal = () => {
    setHistorialPagosAPOpenX(false);
    setSelectedTomax(null);
  };

  // Definir la interfaz para los detalles del cobro
  interface DetallesCobro {
    totalAgua: number;
    totalDrenaje: number;
  }

  // Estado con la interfaz definida
  const [Detalles, setDetalles] = useState<DetallesCobro>({
    totalAgua: 0,
    totalDrenaje: 0,
  });

  const [cobroTotal, setCobroTotal] = useState<number | null>(null);
  // const toast = useToast();

  const [saldoVencidoPredio, setSaldoVencidoPredio] = useState<number>(200);
  const [saldoVencidoAgua, setSaldoVencidoAgua] = useState<number>(150);
  const [esDeudor, setEsDeudor] = useState<boolean>(
    saldoVencidoPredio > 0 || saldoVencidoAgua > 0,
  );
  const [isPagoModalOpen, setPagoModalOpen] = useState(false);
  const [isPagarSaldoVencidoOpen, setPagarSaldoVencidoOpen] = useState(false);
  const [montoRecibido, setMontoRecibido] = useState<number>(0);
  const toast = useToast();

  const handlePagoAdelantado = () => setPagoModalOpen(true);
  const handleCalcularCobro = async () => {
    if (!fechaDesde || !fechaHasta) {
      toast({
        title: 'Fechas requeridas',
        description: 'Por favor, selecciona un rango de fechas válido.',
        status: 'warning',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      // Hacer la solicitud POST a la API
      const response = await axios.post(
        'http://52.91.130.91:5000/api/cCuota/calcula_cobro',
        {
          idToma: selectedToma,
          fechaDesde,
          fechaHasta,
        },
      );

      // Manejar la respuesta
      const { Cobro_Total, Detalles } = response.data;

      setCobroTotal(Cobro_Total);
      setDetalles({
        totalAgua: Detalles.totalAgua,
        totalDrenaje: Detalles.totalDrenaje,
      });

      toast({
        title: 'Cálculo realizado',
        description: `El cobro total es de $${Cobro_Total}.`,
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error('Error al calcular el cobro:', error);
      toast({
        title: 'Error al calcular',
        description: 'No se pudo calcular el cobro. Inténtalo de nuevo.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };
  const handleConfirmarPago = () => {
    toast({
      title: 'Pago Realizado',
      description: 'Su pago adelantado ha sido confirmado.',
      status: 'success',
      duration: 3000,
      isClosable: true,
    });
    setPagoModalOpen(false);
  };

  const handlePagarSaldoVencido = () => {
    const nuevoSaldoPredio = Math.max(0, saldoVencidoPredio - montoRecibido);
    const nuevoSaldoAgua = Math.max(
      0,
      saldoVencidoAgua - (montoRecibido - saldoVencidoPredio),
    );
    setSaldoVencidoPredio(nuevoSaldoPredio);
    setSaldoVencidoAgua(nuevoSaldoAgua);
    setEsDeudor(nuevoSaldoPredio > 0 || nuevoSaldoAgua > 0);

    toast({
      title: 'Pago Realizado',
      description: 'Pago de saldo vencido realizado con éxito.',
      status: 'success',
      duration: 3000,
      isClosable: true,
    });
    setPagarSaldoVencidoOpen(false);
  };

  const handleTabChange = (index: number) => {
    const selected = tomas[index]?.idTomasx;
    setSelectedToma(selected);
    setCobroTotal(null);

    //console.log(tomas[index].Tomasx.Cuenta)
    fetchPagos(
      'AP-' + tomas[index].Tomasx.Cuenta.toString(),
      tomas[index].idTomasx,
    );
  };

  return (
    <Box
      p={8}
      bg="gray.50"
      borderRadius="md"
      boxShadow="md"
      maxW="1000px"
      mx="auto"
    >
      <Heading as="h1" size="lg" color="teal.500" mb={6} textAlign="center">
        Historial de Pagos de Agua Potable
      </Heading>
      <Modal isOpen={isDetailOpen} onClose={onDetailClose} size="6xl">
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
            {selectedPagoId && (
              <TransaccionDetails transaccionId={selectedPagoId} />
            )}
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" onClick={onDetailClose}>
              Cerrar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <HStack spacing={1} mb={6}>
        <Text fontWeight="bold">Desde:</Text>
        <Input type="date" onChange={(e) => setFechaDesde(e.target.value)} />
        <Text fontWeight="bold">Hasta:</Text>
        <Input type="date" onChange={(e) => setFechaHasta(e.target.value)} />
        <HStack spacing={1} mb={6}>
          <Tooltip
            label="Consulta el adeudo del contribuyente"
            aria-label="Tooltip para Calcular Cobro"
          >
            <Button
              colorScheme="teal"
              leftIcon={<FiDollarSign fontSize="20px" />}
              onClick={handleCalcularCobro}
              flex="1" // Asegura que ambos botones compartan el mismo espacio
              borderRadius="base" // Media luna
              p={1} // Reducir el padding para un botón más compacto
            ></Button>
          </Tooltip>
          <Button
            colorScheme="yellow"
            p={1} // Reducir el padding para un botón más compacto
            leftIcon={<FiEdit fontSize="20px" />}
            onClick={onBajaOpen}
            flex="1" // Asegura que ambos botones compartan el mismo espacio
            borderRadius="base" // Media luna
          ></Button>
        </HStack>
      </HStack>

      <Divider mb={6} />

      <Tabs isFitted variant="enclosed" onChange={handleTabChange}>
        <TabList mb="1em">
          {tomas.map((toma) => (
            <Tab key={toma.idTomasx}>Toma: {toma.Tomasx.Cuenta}</Tab>
          ))}
        </TabList>
        <TabPanels>
          {tomas.map((toma) => (
            <TabPanel key={toma.idTomasx}>
              <Box overflowX="auto" maxHeight="350px" overflowY="auto">
                <Table variant="simple" size="md">
                  <Thead>
                    <Tr>
                      <Th>Fecha de Pago</Th>
                      <Th>Monto</Th>
                      <Th>Tipo de Pago</Th>
                      <Th>Estado</Th>
                      <Th>UUID</Th>
                      <Th>Estado de Cancelacion</Th>
                      <Th>Acciones</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {pagos[toma.idTomasx]?.map((pago) => (
                      <Tr key={pago.ID}>
                        <Td>{new Date(pago.Fecha).toLocaleDateString()}</Td>
                        <Td>${pago.Monto}</Td>
                        <Td>{pago.MetodoPago}</Td>
                        <Td color={pago.UUID ? 'green.500' : 'orange.500'}>
                          {pago.UUID ? 'Pagado' : 'Pendiente'}
                        </Td>
                        <Td>{pago.UUID || 'N/A'}</Td>
                        <Td>{pago.estatus_de_cancelacion}</Td>
                        <Menu>
                          <MenuButton
                            as={Button}
                            size="sm"
                            colorScheme="teal"
                            rightIcon={<ChevronDownIcon />}
                          >
                            Opciones
                          </MenuButton>
                          <MenuList>
                            {pago.UUID === null ? (
                              <MenuItem
                                onClick={async () => {
                                  try {
                                    //OBSIDIAN PRUEBAS 2025
                                    const response = await axios.get(
                                      `http://52.91.130.91:5000/api/Facturacion/generarx-prod/${pago.ID}`,
                                      {
                                        responseType: 'blob',
                                      },
                                    );

                                    const xmlBlob = new Blob([response.data], {
                                      type: 'application/xml',
                                    });
                                    const xmlUrl = URL.createObjectURL(xmlBlob);

                                    const link = document.createElement('a');
                                    link.href = xmlUrl;
                                    link.setAttribute(
                                      'download',
                                      `CFDI_${pago.ID}.xml`,
                                    );
                                    document.body.appendChild(link);
                                    link.click();
                                    document.body.removeChild(link);

                                    toast({
                                      title: 'Éxito',
                                      description:
                                        'CFDI generado y descargado correctamente.',
                                      status: 'success',
                                      duration: 5000,
                                      isClosable: true,
                                    });
                                  } catch (error) {
                                    console.error(
                                      'Error al generar el CFDI:',
                                      error,
                                    );
                                    toast({
                                      title: 'Error',
                                      description:
                                        'No se pudo generar el CFDI. Intenta de nuevo.',
                                      status: 'error',
                                      duration: 5000,
                                      isClosable: true,
                                    });
                                  }
                                }}
                              >
                                Facturar
                              </MenuItem>
                            ) : (
                              <MenuItem
                                onClick={async () => {
                                  setLoading(true); // Activa el bloqueo de pantalla

                                  try {
                                    const response = await axios.get(
                                      `http://52.91.130.91:5000/api/Transacciones/ImprimirAgua/` +
                                        pago.ID,
                                      {
                                        responseType: 'blob',
                                      },
                                    );

                                    const pdfBlob = new Blob([response.data], {
                                      type: 'application/pdf',
                                    });
                                    const pdfUrl = URL.createObjectURL(pdfBlob);
                                    window.open(pdfUrl, '_blank');

                                    // const link =
                                    //   document.createElement('a');
                                    // link.href = pdfUrl;
                                    // link.setAttribute(
                                    //   'download',
                                    //   `CFDI_${pago.UUID}.pdf`,
                                    // );
                                    // document.body.appendChild(link);
                                    // link.click();
                                    // document.body.removeChild(link);

                                    toast({
                                      title: 'Éxito',
                                      description:
                                        'CFDI descargado correctamente.',
                                      status: 'success',
                                      duration: 5000,
                                      isClosable: true,
                                    });
                                  } catch (error) {
                                    console.error(
                                      'Error al descargar el CFDI:',
                                      error,
                                    );
                                    toast({
                                      title: 'Error',
                                      description:
                                        'No se pudo descargar el CFDI. Intenta de nuevo.',
                                      status: 'error',
                                      duration: 5000,
                                      isClosable: true,
                                    });
                                  } finally {
                                    setLoading(false);
                                  }
                                }}
                              >
                                Imprimir CFDI
                              </MenuItem>
                            )}
                            <MenuItem onClick={() => handleVerDetalle(pago.ID)}>
                              Ver Detalle
                            </MenuItem>
                            <MenuItem
  onClick={() => {
    const downloadUrl = `http://52.91.130.91:5000/api/Facturacion/descargar/${pago.UUID}`;
    window.open(downloadUrl, '_blank');
  }}
>
  Descargar XML
</MenuItem>

                            <MenuItem
                              onClick={async () => {
                                let toastId; // Identificador para el toast
                                try {
                                  // Mostrar un toast indicando que se está procesando la cancelación
                                  toastId = toast({
                                    title: 'Procesando',
                                    description:
                                      'La cancelación del CFDI está en curso, espera un momento.',
                                    status: 'info',
                                    duration: null, // El toast permanece visible hasta que lo cierres manualmente
                                    isClosable: true,
                                  });

                                  // Datos requeridos por el backend
                                  const requestData = {
                                    user: 'usuario_desde_bd',
                                    pass: 'password_desde_bd',
                                    rfcEmisor: 'RFC_desde_bd',
                                    listaCFDI: [
                                      {
                                        EsCancelable: true, // Supón que el CFDI es cancelable
                                        FolioSustitucion: '', // Si aplica, puedes incluirlo
                                        Motivo: '03', // Motivo de cancelación: "No se llevó a cabo la operación"
                                        RFCReceptor:
                                          pago.RFCReceptor || 'XAXX010101000',
                                        Total: pago.Monto,
                                        UUID: pago.UUID, // UUID del CFDI que se desea cancelar
                                      },
                                    ],
                                  };

                                  // Realizar la solicitud POST al backend
                                  const response = await axios.post(
                                    'http://52.91.130.91:5000/api/Facturacion/cancelar-cfdi',
                                    requestData,
                                    { responseType: 'blob' }, // Asegúrate de recibir el archivo como blob
                                  );

                                  if (response.data) {
                                    // Crear un blob a partir del XML
                                    const xmlBlob = new Blob([response.data], {
                                      type: 'application/xml',
                                    });

                                    // Crear un enlace para descargar el archivo
                                    const xmlUrl = URL.createObjectURL(xmlBlob);
                                    const link = document.createElement('a');
                                    link.href = xmlUrl;
                                    link.setAttribute(
                                      'download',
                                      `Cancelacion_CFDI_${pago.UUID}.xml`,
                                    );

                                    // Simular clic en el enlace para iniciar la descarga
                                    document.body.appendChild(link);
                                    link.click();
                                    document.body.removeChild(link);

                                    // Cerrar el toast de progreso y mostrar uno de éxito
                                    toast.close(toastId);
                                    toast({
                                      title: 'Éxito',
                                      description:
                                        'El CFDI fue cancelado y el XML se descargó correctamente.',
                                      status: 'success',
                                      duration: 5000,
                                      isClosable: true,
                                    });
                                  } else {
                                    // Cerrar el toast de progreso y mostrar uno de error
                                    toast.close(toastId);
                                    toast({
                                      title: 'Error',
                                      description:
                                        'No se pudo cancelar el CFDI. Intenta de nuevo.',
                                      status: 'error',
                                      duration: 5000,
                                      isClosable: true,
                                    });
                                  }
                                } catch (error) {
                                  console.error(
                                    'Error al cancelar el CFDI:',
                                    error,
                                  );

                                  // Cerrar el toast de progreso y mostrar uno de error
                                  toast.close(toastId);
                                  toast({
                                    title: 'Error',
                                    description:
                                      'No se pudo cancelar el CFDI. Intenta de nuevo.',
                                    status: 'error',
                                    duration: 5000,
                                    isClosable: true,
                                  });
                                }
                              }}
                            >
                              Cancelar CFDI
                            </MenuItem>
                          </MenuList>
                        </Menu>
                      </Tr>
                    )) || (
                      <Tr>
                        <Td colSpan={4} textAlign="center">
                          No hay pagos registrados para esta toma.
                        </Td>
                      </Tr>
                    )}
                  </Tbody>
                </Table>
              </Box>

              {cobroTotal !== null && (
                <Flex justify="center" align="center" bg="gray.100">
                  <VStack
                    spacing={4}
                    bg="white"
                    p={4}
                    borderRadius="md"
                    border="1px solid"
                    borderColor="gray.300"
                    boxShadow="lg"
                    width="100%"
                    maxW="450px"
                    alignSelf="center"
                  >
                    <Box
                      textAlign="center"
                      borderBottom="1px solid"
                      borderColor="gray.200"
                      pb={3}
                      width="100%"
                    >
                      <Text fontSize="xl" fontWeight="bold" color="gray.700">
                        Adeudo del Contribuyente
                      </Text>
                      <Text fontSize="sm" color="gray.500">
                        Fecha: {new Date().toLocaleDateString()}
                      </Text>
                    </Box>

                    <VStack spacing={2} align="stretch">
                      <HStack justifyContent="space-between">
                        <Text
                          fontSize="sm"
                          fontWeight="semibold"
                          color="gray.600"
                        >
                          Agua:
                        </Text>
                        <Text
                          fontSize="sm"
                          fontWeight="medium"
                          color="gray.800"
                        >
                          ${Detalles.totalAgua}
                        </Text>
                      </HStack>
                      <HStack justifyContent="space-between">
                        <Text
                          fontSize="sm"
                          fontWeight="semibold"
                          color="gray.600"
                        >
                          Alcantarillado:
                        </Text>
                        <Text
                          fontSize="sm"
                          fontWeight="medium"
                          color="gray.800"
                        >
                          ${Detalles.totalDrenaje}
                        </Text>
                      </HStack>
                      <HStack justifyContent="space-between">
                        <Text
                          fontSize="sm"
                          fontWeight="semibold"
                          color="gray.600"
                        >
                          Recargos:
                        </Text>
                        <Text
                          fontSize="sm"
                          fontWeight="medium"
                          color="gray.800"
                        >
                          ${0.0} (.DEV)
                        </Text>
                      </HStack>
                      <Divider borderColor="gray.300" />
                      <HStack justifyContent="space-between">
                        <Text fontSize="md" fontWeight="bold" color="green.600">
                          TOTAL:
                        </Text>
                        <Text fontSize="md" fontWeight="bold" color="green.600">
                          ${cobroTotal}
                        </Text>
                      </HStack>
                    </VStack>

                    <Box textAlign="center" mt={2}>
                      <HStack spacing={4} justify="center">
                        <Button
                          colorScheme="green"
                          size="md"
                          borderRadius="md"
                          leftIcon={<FaCreditCard />}
                          onClick={() => openPagoModal(toma)}
                        >
                          Pagar Ahora
                        </Button>

                        <Button
                          colorScheme="blue"
                          size="md"
                          borderRadius="md"
                          leftIcon={<FaPrint />}
                          //  onClick={() => handleImprimir(toma.idTomasx, toma.idPropietario)}
                        >
                          Imprimir Estado
                        </Button>
                      </HStack>
                    </Box>
                  </VStack>
                </Flex>
              )}
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
      <Modal isOpen={isBajaOpen} onClose={onBajaClose} size="5xl">
        <ModalOverlay />
        <ModalContent
          bg="transparent" // Hace la modal completamente transparente
          boxShadow="none" // Elimina cualquier sombra
        >
          <ModalCloseButton />
          <ModalBody p={0}>
            <Suspense fallback={<Spinner />}>
              <CrearActualizarToma
                idPropietario={Number(selectedToma)}
                alta={false}
              />
            </Suspense>
          </ModalBody>
        </ModalContent>
      </Modal>

      <Modal
        isOpen={isHistorialPagosAPOpenX}
        onClose={closePagoModal}
        size="6xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
            {selectedToma && (
              <FacturacionComponent
                data={selectedTomax} // Pasamos toda la toma seleccionada
                //idClaveCatastral={selectedTomax.Tomasx.Cuenta}  // Pasar el id de toma
                monto={cobroTotal}
                // pagoid={selectedTomax.idPropietario}  // Pasar el id de propietario
                onClose={closePagoModal} // Pasamos la función de cierre
              />
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default HistorialPagosAP;
